import React, { useEffect, useState } from "react";
import { X } from "lucide-react";
import "./Popup.css";

const ImagePopup = ({ isOpen, closeModal, children }) => {
  const [shouldRender, setShouldRender] = useState(isOpen);
  const [renderedChildren, setRenderedChildren] = useState(children);

  useEffect(() => {
    if (isOpen) {
      setRenderedChildren(children);
      setShouldRender(true);
      return undefined;
    }

    const timer = window.setTimeout(() => setShouldRender(false), 180);
    return () => window.clearTimeout(timer);
  }, [children, isOpen]);

  useEffect(() => {
    if (!isOpen) return undefined;

    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        closeModal();
      }
    };

    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [isOpen, closeModal]);

  if (!shouldRender) return null;

  return (
    <div
      className={`modal-overlay ${isOpen ? "" : "is-closing"}`}
      onClick={closeModal}
      role="presentation"
    >
      <div
        className="modal-content"
        role="dialog"
        aria-modal="true"
        onClick={(event) => event.stopPropagation()}
      >
        {renderedChildren}
        <button
          type="button"
          className="modal-close-btn"
          onClick={closeModal}
          aria-label="Close preview"
        >
          <X size={18} strokeWidth={1.8} aria-hidden="true" />
        </button>
      </div>
    </div>
  );
};

export default ImagePopup;
